import {ApiStatus,type ApiStatusData} from "@/types/site_configuration/ApiStatus";
import {ApiSubstatus, type ApiSubstatusData} from "@/types/site_configuration/ApiSubstatus.ts";

export class AppStatus {
    public id: number | null;
    public name: string;
    public color: string;
    public text_color: string;
    public description: string;
    public info: string;
    public apiStatuses: ApiStatus[];
    public apiSubstatuses: ApiSubstatus[];

    constructor(data: AppStatusData | void) {
        if (data === undefined) {
            this.id = null;
            this.name = "";
            this.color = "";
            this.text_color = "";
            this.description = "";
            this.info = "";
            this.apiStatuses = [];
            this.apiSubstatuses = [];
        } else {
            this.id = data.id;
            this.name = data.name;
            this.color = data.color;
            this.text_color = data.text_color;
            this.description = data.description;
            this.info = data.info;
            this.apiStatuses = [];
            if (data.apiStatuses !== undefined) {
                data.apiStatuses.forEach(apiStatus => this.apiStatuses.push((new ApiStatus(apiStatus))));
            }
            this.apiSubstatuses = [];
            if (data.apiSubstatuses !== undefined) {
                data.apiSubstatuses.forEach(apiSubstatus => this.apiSubstatuses.push((new ApiSubstatus(apiSubstatus))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.name = "";
        this.color = "";
        this.text_color = "";
        this.description = "";
        this.info = "";
        this.apiStatuses = [];
        this.apiSubstatuses = [];
    }

    public serializeData(without_relations: boolean | Array<string> = false): AppStatusData {
        const data = {
            id: this.id,
            name: this.name,
            color: this.color,
            text_color: this.text_color,
            description: this.description,
            info: this.info,
            apiStatuses: [],
        }

        this.apiStatuses.forEach(apiStatus => {
            data.apiStatuses.push(
                new ApiStatus(apiStatus as ApiStatusData).serializeData()
            );
        });
        // if (without_relations === false ||
        //     (
        //         Array.isArray(without_relations) &&
        //         !without_relations.includes('apiStatuses')
        //     )
        // ) {
        //     data.apiStatuses = [];
        //     this.apiStatuses.forEach(el => {
        //         data.apiStatuses.push(el.serializeData())
        //     })
        // }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('apiSubstatuses')
            )
        ) {
            data.apiSubstatuses = [];
            this.apiSubstatuses.forEach(el => {
                data.apiSubstatuses.push(el.serializeData())
            })
        }
        return data;
    }
}

export type AppStatusData = {
    id: number | null;
    name: string;
    color: string;
    text_color: string;
    description: string;
    info: string;
    apiStatuses: ApiStatusData[];
    apiSubstatuses: ApiSubstatusData[];
}